module.exports = __webpack_public_path__ + "assets/images/C-orange-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/C-orange-icon.png
// module id = 388
// module chunks = 1